import * as React from 'react';

import {StarIcon} from 'shells/icon';

export function Star() {
    return (
        <span>
            (<StarIcon size={12} />)
        </span>
    );
}
